"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Drawer = _interopRequireDefault(require("@mui/material/Drawer"));
var _reactBootstrap = require("react-bootstrap");
var _treeUtil = require("../../../treeUtil");
var _buttonV = _interopRequireDefault(require("../../../buttonV2"));
var _styles = _interopRequireDefault(require("../styles.scss"));
var _styles2 = require("../styles");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MultiDrawer = /*#__PURE__*/function (_React$Component, _onLoadNodeList) {
  (0, _inherits2.default)(MultiDrawer, _React$Component);
  var _super = _createSuper(MultiDrawer);
  function MultiDrawer(props) {
    var _this;
    (0, _classCallCheck2.default)(this, MultiDrawer);
    _this = _super.call(this, props);
    _this.state = {
      showDetailPane: false,
      selectedNodeList: [],
      selectedLevel: null,
      selectedLevelDetails: [],
      selectAll: false,
      nodeTree: [],
      nodeList: []
    };
    _this.onClose = _this.onClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderSummaryField = _this.renderSummaryField.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderStructureDetails = _this.renderStructureDetails.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderActions = _this.renderActions.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSubmit = _this.onSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateSelectedNodes = _this.updateSelectedNodes.bind((0, _assertThisInitialized2.default)(_this));
    _this.onLoadNodeList = _this.onLoadNodeList.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderSelectAll = _this.renderSelectAll.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClickSelectAll = _this.handleClickSelectAll.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(MultiDrawer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onLoadNodeList(this.props.selectedNodeList);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.show && this.props.show !== prevProps.show || this.props.selectedNodeList !== prevProps.selectedNodeList) {
        this.onLoadNodeList(this.props.selectedNodeList);
      }
    }
  }, {
    key: "onLoadNodeList",
    value: function onLoadNodeList(_x) {
      return (_onLoadNodeList = _onLoadNodeList || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(initialNodeList) {
        var _this$props, nodeList, onLoad, nodeTree, initialNodeIds, processTree, updatedNodeList;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, nodeList = _this$props.nodeList, onLoad = _this$props.onLoad;
              nodeTree = (0, _treeUtil.createTree)(nodeList);
              initialNodeIds = initialNodeList.length < 1 && nodeTree.length === 1 ? [nodeTree[0].nodeId] : initialNodeList.map(function (node) {
                return node.nodeId;
              });
              processTree = function processTree(data) {
                if (!data) {
                  return false;
                }
                var _loop = function _loop() {
                  var node = data[i];
                  if (initialNodeIds.some(function (n) {
                    return n === node.nodeId;
                  })) {
                    node.checked = true;
                    (0, _treeUtil.updateParents)(nodeTree, node, true);
                  }
                  if (node.children) {
                    processTree(node.children);
                  }
                };
                for (var i = 0; i < data.length; i++) {
                  _loop();
                }
                return data;
              };
              if (nodeTree.length === 1) {
                nodeTree[0].disabled = true;
                nodeTree[0].checked = true;
              }
              if (initialNodeIds.length > 0) {
                processTree(nodeTree);
              }
              updatedNodeList = (0, _treeUtil.flatten)(nodeTree);
              onLoad(updatedNodeList.filter(function (node) {
                return node.checked;
              }));
              _context.next = 10;
              return this.setState({
                nodeTree: nodeTree,
                nodeList: updatedNodeList,
                selectedNodeList: updatedNodeList.filter(function (node) {
                  return node.checked;
                })
              });
            case 10:
              this.onSubmit();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.setState({
        showDetailPane: false,
        selectedLevel: null
      });
      this.props.onClose();
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var nodeList = this.state.nodeList;
      var selectedNodeList = this.props.selectedNodeList;
      var selectedNodes = nodeList.filter(function (node) {
        return node.checked;
      });
      var leafNodes = [];
      // add nodes with no selected children to leafNodes
      selectedNodes.forEach(function (node) {
        return !node.children.some(function (n) {
          return n.checked;
        }) ? leafNodes.push(node) : null;
      });
      // return if nodes haven't changed
      var oldNodeIds = selectedNodeList.map(function (n) {
        return n.nodeId;
      });
      var newNodeIds = leafNodes.map(function (n) {
        return n.nodeId;
      });
      if (newNodeIds.length === oldNodeIds.length && newNodeIds.every(function (id) {
        return oldNodeIds.includes(id);
      })) {
        return;
      }
      // prevent circular refrences when segmentation is saved
      var prunedLeafNodes = leafNodes.map(function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          children: [],
          ancestors: []
        });
      });
      this.props.onSave(prunedLeafNodes, selectedNodes, leafNodes);
      this.onClose();
    }

    /**
     * get all node by level and current selected node
     * @param {String} level
     * @return {Array} list node
     */
  }, {
    key: "getAllNodeByLevel",
    value: function getAllNodeByLevel(level) {
      var _this$state = this.state,
        selectedNodeList = _this$state.selectedNodeList,
        nodeList = _this$state.nodeList,
        nodeTree = _this$state.nodeTree,
        selectedLevel = _this$state.selectedLevel;
      var levels = this.props.levels;
      var visibleNodes = [];
      var tree = nodeTree.slice(0);
      var getAllLevelNodes = function getAllLevelNodes(nodeLevel) {
        return nodeList.filter(function (node) {
          return node.levelIndex === levels[nodeLevel].levelIndex;
        });
      };
      var processTree = function processTree(data) {
        if (!data) {
          return false;
        }
        for (var i = 0; i < data.length; i++) {
          var node = data[i];
          if (node.levelId === level) {
            // show root level and checked nodes
            if (node.levelIndex === levels[0].levelIndex || node.checked) {
              if (visibleNodes.includes(node)) {
                return false;
              }
              visibleNodes.push(node);
            } else if (
            // if root node is checked and no parents are checked,
            // show all children of the root
            node.ancestors.length > 0 && node.ancestors[0].checked && getAllLevelNodes(0).filter(function (n) {
              return n.checked;
            }).includes(node.ancestors[0]) && getAllLevelNodes(node.levelIndex - 1).every(function (n) {
              return !n.checked;
            })) {
              if (visibleNodes.includes(node)) {
                return false;
              }
              visibleNodes.push(node);
            } else if (
            // if parent is checked, only show its children
            node.ancestors.length > 0 && node.ancestors[node.ancestors.length - 2].checked) {
              if (visibleNodes.includes(node)) {
                return false;
              }
              visibleNodes.push(node);
            }
          }
          if (node.children) {
            processTree(node.children);
          }
        }
        return data;
      };
      if (selectedNodeList.length > 0) {
        processTree(tree);
      }
      var selectedLevelDetails = selectedNodeList.length > 0 && levels.length !== 1 && level !== selectedLevel ? visibleNodes : nodeList.filter(function (node) {
        return node.levelId === level;
      });
      return {
        selectedLevelDetails: selectedLevelDetails,
        visibleNodes: visibleNodes
      };
    }
  }, {
    key: "handleClickViewAll",
    value: function handleClickViewAll(level) {
      var _this$getAllNodeByLev = this.getAllNodeByLevel(level),
        selectedLevelDetails = _this$getAllNodeByLev.selectedLevelDetails,
        visibleNodes = _this$getAllNodeByLev.visibleNodes;
      this.setState({
        selectAll: visibleNodes.length > 1 && visibleNodes.every(function (n) {
          return n.checked;
        }),
        showDetailPane: true,
        selectedLevel: level,
        selectedLevelDetails: selectedLevelDetails
      });
    }
  }, {
    key: "handleClickSelectAll",
    value: function handleClickSelectAll() {
      var _this$state2 = this.state,
        selectAll = _this$state2.selectAll,
        selectedLevelDetails = _this$state2.selectedLevelDetails,
        nodeTree = _this$state2.nodeTree;
      var tree = nodeTree.slice(0);
      var levelNodeIds = selectedLevelDetails.map(function (node) {
        return node.nodeId;
      });
      this.setState({
        selectAll: !selectAll
      });
      var processTree = function processTree(data) {
        if (!data) {
          return false;
        }
        var _loop2 = function _loop2() {
          var node = data[i];
          if (levelNodeIds.some(function (n) {
            return n === node.nodeId;
          })) {
            if (!selectAll) {
              node.checked = true;
              (0, _treeUtil.updateParents)(tree, node, true);
            } else {
              node.checked = false;
              (0, _treeUtil.updateChildren)(node, false);
            }
          }
          if (node.children) {
            processTree(node.children);
          }
        };
        for (var i = 0; i < data.length; i++) {
          _loop2();
        }
        return data;
      };
      processTree(tree);
      var updatedNodeList = (0, _treeUtil.flatten)(tree);
      this.setState({
        nodeTree: tree,
        selectedNodeList: updatedNodeList.filter(function (n) {
          return n.checked;
        }),
        nodeList: updatedNodeList
      });
    }
  }, {
    key: "updateSelectedNodes",
    value: function updateSelectedNodes(clickedNode) {
      var _this$state3 = this.state,
        nodeTree = _this$state3.nodeTree,
        selectedLevelDetails = _this$state3.selectedLevelDetails;
      var tree = nodeTree.slice(0);
      var processTree = function processTree(data) {
        if (!data) {
          return false;
        }
        for (var i = 0; i < data.length; i++) {
          var node = data[i];
          if (clickedNode.nodeId === node.nodeId) {
            if (node.checked === true) {
              node.checked = false;
              (0, _treeUtil.updateChildren)(node, false);
            } else {
              node.checked = true;
              (0, _treeUtil.updateParents)(tree, node, true);
            }
          }
          if (node.children) {
            processTree(node.children);
          }
        }
        return data;
      };
      processTree(tree);
      var updatedNodeList = (0, _treeUtil.flatten)(tree);
      this.setState({
        nodeTree: tree,
        selectedNodeList: updatedNodeList.filter(function (n) {
          return n.checked;
        }),
        nodeList: updatedNodeList,
        selectAll: selectedLevelDetails.length > 1 && selectedLevelDetails.every(function (n) {
          return n.checked;
        })
      });
    }
  }, {
    key: "renderSummaryField",
    value: function renderSummaryField(name, currentLevel) {
      var _this2 = this;
      var t = this.props.t;
      var _this$state4 = this.state,
        selectedLevel = _this$state4.selectedLevel,
        nodeList = _this$state4.nodeList;
      var levelNodes = nodeList.filter(function (node) {
        return node.levelId === currentLevel;
      });
      var checkedNodes = levelNodes.filter(function (node) {
        return node.checked;
      });
      var _this$getAllNodeByLev2 = this.getAllNodeByLevel(currentLevel),
        selectedLevelDetails = _this$getAllNodeByLev2.selectedLevelDetails;

      // don't show current summary field when this level don't have node
      if (levelNodes.length === 0 || selectedLevelDetails.length === 0) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "summary-structure-field ".concat(currentLevel === selectedLevel ? 'active' : ''),
        key: "summary-".concat(currentLevel)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "title-hierarchy"
      }, name, " (", checkedNodes.length, ")", /*#__PURE__*/_react.default.createElement("span", {
        className: "view-all-btn-holder"
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          className: 'view-all-btn',
          variant: 'text',
          sx: _styles2.viewAllBtn,
          endIcon: /*#__PURE__*/_react.default.createElement("i", {
            className: "fa fa-arrow-right",
            "aria-hidden": "true"
          }),
          onClick: function onClick() {
            return _this2.handleClickViewAll(currentLevel);
          }
        }
      }, t('View All')))), checkedNodes.length > 0 ? /*#__PURE__*/_react.default.createElement("ul", null, checkedNodes.sort(function (a, b) {
        return a.nodeName > b.nodeName ? 1 : -1;
      }).map(function (node) {
        return node.levelId === currentLevel ? /*#__PURE__*/_react.default.createElement("li", {
          className: "small-text"
        }, node.nodeName) : null;
      })) : /*#__PURE__*/_react.default.createElement("div", {
        className: "small-text"
      }, t('Select'), " ", name));
    }
  }, {
    key: "renderStructureDetails",
    value: function renderStructureDetails(levelNodes) {
      var _this3 = this;
      // sort list and keep unset nodes at the bottom
      var unsetNodes = levelNodes.filter(function (node) {
        return node.nodeId.match(/-unset/);
      }).sort(function (a, b) {
        return a.nodeName.toLowerCase().localeCompare(b.nodeName.toLowerCase());
      });
      var standardNodes = levelNodes.filter(function (node) {
        return !node.nodeId.match(/-unset/);
      }).sort(function (a, b) {
        return a.nodeName.toLowerCase().localeCompare(b.nodeName.toLowerCase());
      });
      var sortedNodes = standardNodes.concat(unsetNodes);
      return sortedNodes.map(function (node) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "node-".concat(node.nodeId),
          className: "structure-details-field"
        }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Checkbox, {
          inline: true,
          "data-checked": node.checked,
          checked: node.checked,
          onChange: function onChange() {
            return _this3.updateSelectedNodes(node);
          },
          disabled: node.disabled,
          className: "container"
        }, /*#__PURE__*/_react.default.createElement("span", null, node.nodeName), /*#__PURE__*/_react.default.createElement("span", {
          className: "checkmark"
        })));
      });
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this4 = this;
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "actions-btn"
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          onClick: function onClick() {
            return _this4.onSubmit();
          }
        }
      }, t('Save')), /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          sx: _styles2.cancelBtn,
          color: 'secondary',
          variant: 'outlined',
          onClick: function onClick() {
            return _this4.onClose();
          }
        }
      }, t('Cancel')));
    }
  }, {
    key: "renderSelectAll",
    value: function renderSelectAll() {
      var _this5 = this;
      var selectAll = this.state.selectAll;
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Checkbox, {
        inline: true,
        "data-checked": selectAll,
        checked: selectAll,
        className: "select-all",
        onChange: function onChange() {
          return _this5.handleClickSelectAll();
        }
      }, /*#__PURE__*/_react.default.createElement("span", null, t('Select All')), /*#__PURE__*/_react.default.createElement("span", {
        className: "checkmark"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$state5 = this.state,
        showDetailPane = _this$state5.showDetailPane,
        selectedLevelDetails = _this$state5.selectedLevelDetails,
        selectedLevel = _this$state5.selectedLevel;
      var _this$props2 = this.props,
        show = _this$props2.show,
        levels = _this$props2.levels,
        t = _this$props2.t;
      return /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        className: "".concat(showDetailPane ? _styles.default['full-drawer-container'] : _styles.default['half-drawer-container']),
        anchor: "right",
        open: show,
        onClose: function onClose() {
          return _this6.onClose();
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "structure-summary"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "org-title"
      }, t('Organizational Structure:')), /*#__PURE__*/_react.default.createElement("div", {
        className: "level-container"
      }, levels.map(function (o) {
        return _this6.renderSummaryField(t(o.levelName), o.levelId);
      }), this.renderActions())), showDetailPane && /*#__PURE__*/_react.default.createElement(_Drawer.default, {
        className: _styles.default['structure-detail-drawer'],
        anchor: "right",
        variant: "persistent",
        open: showDetailPane
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "structure-detail"
      }, /*#__PURE__*/_react.default.createElement(_buttonV.default, {
        muiButtonProps: {
          variant: 'text',
          color: 'text',
          endIcon: /*#__PURE__*/_react.default.createElement("i", {
            className: "fa fa-times",
            "aria-hidden": "true"
          }),
          sx: _styles2.closeBtn,
          onClick: function onClick() {
            return _this6.setState({
              showDetailPane: false,
              selectedLevel: null
            });
          }
        }
      }, t('Close')), /*#__PURE__*/_react.default.createElement("div", {
        className: "line-title"
      }, selectedLevel === levels[0].levelId && selectedLevelDetails.length <= 1 ? /*#__PURE__*/_react.default.createElement("div", {
        className: "select-all-placeholder"
      }) : this.renderSelectAll()), /*#__PURE__*/_react.default.createElement("hr", null), this.renderStructureDetails(selectedLevelDetails))));
    }
  }]);
  return MultiDrawer;
}(_react.default.Component);
MultiDrawer.propTypes = {
  show: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onSave: _propTypes.default.func.isRequired,
  onLoad: _propTypes.default.func.isRequired,
  selectedNodeList: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  nodeList: _propTypes.default.arrayOf(_propTypes.default.shape({})),
  levels: _propTypes.default.arrayOf(_propTypes.default.shape({
    levelName: _propTypes.default.string,
    levelId: _propTypes.default.string,
    levelIndex: _propTypes.default.number
  })),
  t: _propTypes.default.func
};
MultiDrawer.defaultProps = {
  selectedNodeList: [],
  nodeList: [],
  levels: [],
  t: function t(x) {
    return x;
  }
};
var _default = MultiDrawer;
exports.default = _default;